/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WcStressRiskAssessmentType {
  Workload = 'Workload',
  ShiftPatterns = 'ShiftPatterns',
  LineManagementIssues = 'LineManagementIssues',
  ControlAutonomy = 'ControlAutonomy',
  ResourcesToDoMyJob = 'ResourcesToDoMyJob',
  RelationshipsInTheTeam = 'RelationshipsInTheTeam',
  ManagementOfChange = 'ManagementOfChange',
  UnderstandingMyJobRole = 'UnderstandingMyJobRole',
  Other = 'Other',
  TrainingAndCompetence = 'TrainingAndCompetence'
}
